<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     阶梯价格展示
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-popover
    placement="bottom-start"
    :width="320"
    trigger="hover"
    popper-class="display-pop"
    :open-delay="200"
    :visible-arrow="false">
    <div class="display-content">
      <el-table :data="advanced_prices" style="width: 100%;">
        <el-table-column label="等级">
          <template slot-scope="scope">
            <el-rate
              v-model="scope.row.level"
              disabled-void-color="transparent"
              disabled>
            </el-rate>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.price | currency }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="reference" class="ml-sm text-primary font-md tag">
      <i role="button" class="iconfont icon-tag"></i>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'TierPricingDisplay',

  components: {
  },

  props: {
    advanced_prices: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
.tag {
  font-size: 20px;
  line-height: 27px;
  transform: rotate(-90deg);
}
</style>
